<template>
  <OArticleCard v-bind="$attrs" class="bg-white w-full flex flex-col sm:flex-row sm:flex-nowrap rounded-none sm:rounded-md">
    <template #desktop>
      <OArticleCover width="275" height="155" class="flex-shrink-0 rounded-l-md" />
      <OArticleBadge pin="left" />
      <div class="p-4 space-y-1.5">
        <OArticleTitle class="hover:text-link-primary text-xl leading-22 tracking-tight line-clamp-2" />
        <OArticleDescription class="text-md leading-22 font-normal text-primary-200 line-clamp-2 tracking-tight" />
        <div class="flex items-center">
          <OArticleHashtag class="leading-22 mr-auto" />
          <OArticleWatchVideo type="card" class="ml-auto" />
        </div>
        <OArticleLiveCount class="absolute right-4 bottom-4" />
      </div>
    </template>
    <template #mobile>
      <OArticleCover class="w-full flex-shrink-0" />
      <OArticleBadge pin="left" />
      <div class="p-4 space-y-1">
        <OArticleTitle class="hover:text-link-primary text-primary-100 text-lg leading-22 tracking-tight line-clamp-2" />
        <OArticleDescription class="text-md leading-22 font-normal text-primary-200 line-clamp-2 tracking-tight" />
        <div class="flex justify-between items-center">
          <OArticleHashtag class="leading-22" />
          <OArticleLiveCount class="ml-auto" />
        </div>
      </div>
    </template>
  </OArticleCard>
</template>
<script>
import { defineComponent } from '@nuxtjs/composition-api';
import OArticleDescription from '@/modules/card/components/ArticleDescription';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';
import OArticleBadge from '@/modules/card/components/ArticleBadge';
import OArticleLiveCount from '@/modules/card/components/ArticleLiveCount';
import OArticleCard from '~/modules/card/components/ArticleCard';
import OArticleCover from '~/modules/card/components/ArticleCover';
import OArticleTitle from '~/modules/card/components/ArticleTitle';
import OArticleWatchVideo from '~/modules/card/components/ArticleWatchVideo';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleDescription,
    OArticleHashtag,
    OArticleBadge,
    OArticleWatchVideo,
    OArticleLiveCount,
  },
  inheritAttrs: false,
});
</script>
